import React from 'react';
import styled from 'styled-components';
import { fonts } from '../common/mixins.js';
const OrderTitle = ({ orderNumber }) => {

    const Container = styled.div`
    display:flex;
    flex-direction:column;                  
    `; 

    const StyledTitle = styled.div`
    ${fonts.title()};
    width:fit-content;
    display:flex;  
    flex-shrink: 0;                 
    @media (max-width: 600px) { 
        font-size: 16px;
    }
    `; 

    return (
        <Container>
        <StyledTitle >
                {orderdetails_resources.MyOrder} #<span id="orderId">{orderNumber}</span>
            </StyledTitle>
        </Container>
    );
};

export default OrderTitle;